import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { AuthService } from 'src/app/service/auth.service';
import { UtilService } from 'src/app/service/util.service';
import { API, API_QRCODE } from 'src/environments/environment';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pesquisa-formulario',
  templateUrl: './pesquisa-formulario.component.html',
  styleUrls: ['./pesquisa-formulario.component.scss']
})
export class PesquisaFormularioComponent implements OnInit {

  public arrayTriagem: [];
  query: string;

  constructor(
    private router: Router,
    private ajax: AjaxService,
    public util: UtilService,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.buscar();
  }

  mostrarLink(item){
    console.log(item.iD_TRIAGEM);
    let message = ' ' +
    '<div class="modal-body"> ' +
    '		<h4 class="mb-2">URL</h4> ' +
    '		<div class="form-group mb-4"> ' +
    '			<input type="text" value="' + API_QRCODE + item.iD_TRIAGEM+ '" class="form-control pl-2" readonly=""> ' +
    '		</div>' +
    '<div>' ;

    Swal.fire({
      title: item.titulo,
      type: 'warning',
      html: message,
      //width: '95%'
    }).then((result) => {

    });

  } 

  buscar(){
    this.util.showLoading();
    let url = API + "Triagem/Triagem?TIPO=F";  
    return this.ajax.get(url)
    .subscribe(response  => {
      this.arrayTriagem = response.data;

      this.util.closeLoading();      
    }, err => {
      debugger
      this.util.closeLoading();
      this.util.toasterShowError("Atenção", "Erro ao Buscar Formulario");
    });
  }

  editar(id: string){
    this.router.navigate(['/editar-formulario',id]);
  }


  desabilitar(id: string) {

    debugger
    let dados = {
      "id": id
    }
    let url = API + "Triagem/Triagem/Desabilitar/" + id;
    return this.ajax.post(url, dados)
      .subscribe(response => {

        this.util.closeLoading();
        this.util.toasterShowSuccess("Atenção", "Formulario Desabilitado com Sucesso");
        this.buscar();
      }, err => {
        debugger
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Salvar Formulario");
      });

  }

}
